import { STREAM_HEIGHT, STREAM_HEIGHT_COMPACT } from '@app/modules/logger/screens/status/constants';
import { useStatusViewContext } from '../../../context/StatusViewContext';
import { WaveformLoader } from './WaveformLoader';

/**
 * Loading state component that displays a waveform skeleton loader.
 */
export function StatusWaveformLoader() {
  const { compact } = useStatusViewContext();

  return <WaveformLoader height={compact ? STREAM_HEIGHT_COMPACT : STREAM_HEIGHT} />;
}
